import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { notification } from 'antd';
import { StateModel } from '../redux/models/state.model';
import { useAppDispatch } from '../redux/store';
import { resetNotificationMessage } from '../redux/reducers/notificationMesageReducer';
import {
  CheckCircleOutline as CheckCircleIcon,
  ErrorOutline as ErrorIcon,
} from '@mui/icons-material';
import CloseIcon from '@mui/icons-material/Close';

export const useNotificationManager = () => {
  const dispatch = useAppDispatch();
  const notificationMessage = useSelector((state: StateModel) => state.notificationMessage);

  const [activeCount, setActiveCount] = useState(0);

  useEffect(() => {
    if (notificationMessage) {
      const type = notificationMessage.isSuccess ? 'success' : 'error';
      const key = `notification-${Date.now()}`;

      const notificationStyle: React.CSSProperties = {
        backgroundColor: 'var(--palette-background-paper)',
        borderRadius: '4px',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
        borderLeft: `5px solid ${type === 'success' ? 'var(--palette-success-main' : 'var(--palette-error-main'}`,
        color: 'var(--palette-text-primary)',
      };

      const icon =
        type === 'success' ? (
          <CheckCircleIcon style={{ color: 'var(--palette-success-main' }} />
        ) : (
          <ErrorIcon style={{ color: 'var(--palette-error-main' }} />
        );

      notification.open({
        key,
        message: (
          <span style={{ color: 'var(--palette-text-primary' }}>{notificationMessage.message}</span>
        ),
        icon,
        closeIcon: (
          <CloseIcon
            style={{
              color: 'var(--palette-error-main)',
            }}
          />
        ),
        style: notificationStyle,
        showProgress: true,
        pauseOnHover: true,
        duration: 3,
        onClose: () => {
          setActiveCount((prev) => Math.max(0, prev - 1));
        },
      });

      setActiveCount((prev) => prev + 1);
      dispatch(resetNotificationMessage());
    }
  }, [notificationMessage, dispatch]);

  const destroyAll = () => {
    notification.destroy();
    setActiveCount(0);
  };

  return {
    activeCount,
    destroyAll,
  };
};
